import * as pages from '../actions/pages.actions'

import { UXPage } from '../../core/models/ux-page';

import { getNewTtl } from '../../core/helpers/date'

import * as auth from '../../auth/actions/auth.actions'

export interface State {
    error: any
    loading: boolean
    pages: UXPage[]
    pagesTtl: Date
}

const initialState: State = {
    error: null,
    loading: false,
    pages: [],
    pagesTtl: null
}

export function reducer(
    state = initialState,
    action: pages.Actions | auth.Actions
) {
    switch(action.type) {
        case pages.GET:
            return {
                ...state,
                loading: true
            }

        case pages.GET_SKIPPED:
            return {
              ...state,
              loading: false
            }

        case pages.GET_SUCCESS:
            return {
                ...state,
                pages: action.payload,
                loading: false,
                pagesTtl: getNewTtl()
            }

        case pages.GET_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        case auth.LOGOUT:
            return initialState

        default:
            return state
    }
}

// State Selectors
export const isLoading = (state: State) => state.loading
export const getPages = (state: State) => state.pages
export const getError = (state: State) => state.error
export const isPagesTtlExpired = (state: State) => state.pagesTtl === null || (state.pagesTtl < new Date())
